// CSV download helpers (semicolon-separated with a UTF-8 BOM, which is what
// Dutch Excel opens without an import wizard).

export function csvEscape(v: string | number | null | undefined, sep = ';'): string {
  const s = v == null ? '' : String(v);
  return s.includes(sep) || /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

export function toCsv(rows: (string | number | null | undefined)[][], sep = ';'): string {
  return rows.map((r) => r.map((v) => csvEscape(v, sep)).join(sep)).join('\n');
}

export function downloadCsv(filename: string, rows: (string | number | null | undefined)[][], sep = ';') {
  const blob = new Blob(['﻿' + toCsv(rows, sep)], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
